import { render } from "./Forms.vue?vue&type=template&id=19cdca67&scoped=true"
import script from "./Forms.vue?vue&type=script&lang=js"
export * from "./Forms.vue?vue&type=script&lang=js"

import "./Forms.vue?vue&type=style&index=0&id=19cdca67&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cdca67"]])

export default __exports__